import React from "react";
import {
  Card,
  Button,
  CardImg,
  CardTitle,
  CardText,
  CardDeck,
  CardBlock,
  CardFooter
} from "reactstrap";

import showerIcon from "./images/shower.svg";
import mirrorIcon from "./images/mirror.svg";
import storefrontIcon from "./images/building.svg";

const Example = props => {
  return (
    <CardDeck style={{ margin: "20px" }}>
      <Card outline color="primary">
        <CardImg top width="100%" src={storefrontIcon} alt="Card image cap" />
        <CardBlock>
          <CardTitle>Commercial Products</CardTitle>
          <CardText>
            We design, fabricate, and install commercial glass systems.
          </CardText>
        </CardBlock>
        <CardFooter>
          <Button color="primary" href="/commercialproducts">
            Learn More
          </Button>
        </CardFooter>
      </Card>
      <Card outline color="primary">
        <CardBlock>
          <CardTitle>Majestic Shower Doors</CardTitle>
          <CardText>
            Add that final touch to your home with a beautiful custom glass
            shower enclosure, installed by Red River Glazing.
          </CardText>
        </CardBlock>
        <CardImg bottom width="100%" src={showerIcon} alt="Card image cap" />
        <CardFooter>
          <Button color="primary" href="/showers">
            Learn More
          </Button>
        </CardFooter>
      </Card>
      <Card outline color="primary">
        <CardImg top width="100%" src={mirrorIcon} alt="Card image cap" />
        <CardBlock>
          <CardTitle>Custom Mirrors</CardTitle>
          <CardText>
            Add that final touch to your home with a beautiful custom glass
            shower enclosure, installed by Red River Glazing.
          </CardText>
        </CardBlock>
        <CardFooter>
          <Button color="primary" href="/mirrors">
            Learn More
          </Button>
        </CardFooter>
      </Card>
    </CardDeck>
  );
};

export default Example;



// WEBPACK FOOTER //
// ./src/IconDeck.js